import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import initDataDog from '../../utils/dataDogRum';

if (process.env.LOCAL !== 'true') {
  initDataDog();
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('missing root element');

// E2E only: start MSW so Cypress runs against mocked APIs with no backend.
// Gated by the E2E flag + dynamic import so the worker is excluded from prod bundles.
const startMockServiceWorker = async () => {
  if (process.env.E2E === 'true') {
    // Simulate the prod Carvana shell initialising @carvana/core-auth. The shell calls RegisterAuth
    // (which creates core-auth's Logger); served standalone under Cypress there is no shell, so
    // UserRefreshToken() - used by the control_fixed 401 -> refresh -> retry path - would otherwise
    // throw "Cannot read properties of undefined (reading 'start')" on Logger. E2E-gated, prod-safe.
    const { RegisterAuth } = await import('@carvana/core-auth');
    RegisterAuth({ environment: process.env.NODE_ENV, isLocalInstance: true, disableLogger: true });

    const { worker } = await import('../../mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }
};

startMockServiceWorker().finally(() => {
  createRoot(rootElement).render((<App />) as any);
});
